import { useState } from 'preact/hooks';

interface Props {
  onSubmit: (code: string) => void;
}

export function CodeEntry({ onSubmit }: Props) {
  const [code, setCode] = useState('');
  const trimmed = code.trim().toUpperCase();
  const valid = /^[A-Z0-9]{6,12}$/.test(trimmed);

  return (
    <main style={mainStyle}>
      <header style={headerStyle}>
        <div style={{ fontSize: 13, letterSpacing: 2, color: 'var(--text-muted)' }}>AIVOX LISTEN</div>
        <h1 style={{ margin: '12px 0 6px', fontSize: 28, fontWeight: 700 }}>Enter session code</h1>
        <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: 15 }}>
          Or scan the QR code shown by the speaker.
        </p>
      </header>

      <form
        onSubmit={(e) => { e.preventDefault(); if (valid) onSubmit(trimmed); }}
        style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
      >
        <input
          type="text"
          inputMode="text"
          autoCapitalize="characters"
          autoCorrect="off"
          spellcheck={false}
          maxLength={12}
          placeholder="ABCD1234"
          value={code}
          onInput={(e) => setCode((e.currentTarget as HTMLInputElement).value)}
          style={inputStyle}
        />
        <button type="submit" disabled={!valid} style={btnStyle(valid)}>Join</button>
      </form>

      <footer style={{ marginTop: 'auto', fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', paddingTop: 32 }}>
        Powered by AIVOX · Live translation
      </footer>
    </main>
  );
}

const mainStyle: any = { padding: '40px 24px', maxWidth: 480, margin: '0 auto', display: 'flex', flexDirection: 'column', minHeight: '100dvh' };
const headerStyle: any = { textAlign: 'center', marginBottom: 32 };
const inputStyle: any = {
  width: '100%', padding: '18px 20px', fontSize: 24, letterSpacing: 4, textAlign: 'center',
  background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)',
  borderRadius: 12, outline: 'none', fontFamily: 'ui-monospace, "SF Mono", monospace',
  textTransform: 'uppercase',
};
const btnStyle = (enabled: boolean): any => ({
  padding: '16px 24px', fontSize: 17, fontWeight: 600, borderRadius: 12, border: 0,
  background: enabled ? 'var(--accent)' : '#2A313C',
  color: enabled ? '#fff' : 'var(--text-muted)',
  cursor: enabled ? 'pointer' : 'not-allowed',
});
